import React from 'react'
import { useI18next, I18nextContext } from 'gatsby-plugin-react-i18next'
import { ILanguage } from 'src/i18n'
import clsx from 'clsx';
import { setIsMenuOpen } from '../side-menu/side-menu-store';
import { useIsLargeScreen } from 'src/helpers/ScreenSizeContext';

const { languages } = require('src/i18n') as { languages: ILanguage[] }

interface ILanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher = ({ 
  className,
}: ILanguageSwitcherProps) => {
  const { changeLanguage } = useI18next()
  const { language } = React.useContext(I18nextContext)
  const isLarge = useIsLargeScreen()

  return (
    <ul className={clsx('flex gap-4', className)}>
      {languages.map(({ code, label}) => (
        <li key={code}>
          <button
            type="button"
            onClick={() => {
              changeLanguage(code)
              if (!isLarge) {
                setIsMenuOpen(false)
              }
            }}
            className={code === language ? 'text-white' : undefined}
          >
            {label}
          </button>
        </li>
      ))}
    </ul>
  )
}

export default LanguageSwitcher
